import { Component, OnInit, Input } from '@angular/core';

import { Product } from '../../../core/models/product';
import { Stock } from '../../../catalog/models/stock';

import * as moment from 'moment';


@Component({
  selector: 'app-stock-info',
  templateUrl: './stock-info.component.html',
  styleUrls: ['./stock-info.component.scss']
})
export class StockInfoComponent implements OnInit {
  @Input() product: Product;
  @Input() layout: string = 'compact';

  constructor() { }

  ngOnInit() {
  }

  get firstAvailableStock(): Stock {
    if (this.product && this.product.stock && this.product.stock.length) {
      const currentStock = this.product.stock.find(stock => stock.type === 'current')
      let futureStock = this.product.stock.filter(stock => stock.type === 'future')

      if (currentStock && currentStock.quantity) {
        return currentStock;
      }

      if (futureStock && futureStock.length) {
        futureStock = futureStock.sort(((a, b) => {
          if (a.date < b.date)
            return -1
          if (a.date > b.date)
            return 1
          return 0
        }))

        const firstAvailableFutureStock = futureStock[0]
        return firstAvailableFutureStock;
      }
    }

    // No stock (return null)
    return
  }

  get isCompactLayout(): boolean {
    return this.layout === 'compact';
  }

  get isInCurrentStock(): boolean {
    const stock = this.firstAvailableStock;

    if (stock) {
      return stock.type === 'current';
    }

    return false;
  }

  get isInFutureStock(): boolean {
    const stock = this.firstAvailableStock;

    if (stock) {
      return stock.type === 'future';
    }

    return false;
  }

  get isOutOfStock(): boolean {
    const stock = this.firstAvailableStock;

    if (!stock) {
      return true;
    }

    return false;
  }

  get quantity(): number {
    const stock = this.firstAvailableStock;

    if (stock) {
      return stock.quantity;
    }

    return 0;
  }

  get week(): string {
    const stock = this.firstAvailableStock;

    if (stock && stock.type === 'future') {
      const date = moment(stock.date);

      if (date.isValid()) {
        return  date.format('w');
      }
    }

    return '';
  }
}
